/* jQuery COMPONENTS knockDoorway */

COMPONENTS.ComponentsAnchors = (function ($) {
  function ComponentsAnchors () {
    // Grab a reference to all <a> tags on the page
    this.$anchors = $('a')
  }

  ComponentsAnchors.prototype.init = function () {
    // On init iterate the anchor tags
    this.$anchors.each(function () {
      // Set a scoped reference to the anchor and href
      const $anchor = $(this)
      // If it doesn't have an href make sure to pass along an empty string
      // to the rest of the functiob below to prevent undefined errors
      const href = ($anchor.attr('href') ? $anchor.attr('href') : '')
      const dataSpacesControl = ($anchor.data('spaces-control') ? $anchor.data('spaces-control') : '')

      // Handle knock tours links
      if (href.includes('#knock-tour')) {
        $anchor.click(function (e) {
          e.preventDefault()
          knockDoorway.openScheduling()
        })
      }

      // Handle Knock contact links
      if (href.includes('#knock-contact')) {
        $anchor.click(function (e) {
          e.preventDefault()
          knockDoorway.openContact()
        })
      }

      // Handle specials links
      if (href.includes('#specials')) {
        $anchor.click(function (e) {
          e.preventDefault()
          $('[data-ecs-components-control="specials-trigger"]').trigger('click')
        })
      }

      // Handle SightMap links
      if (href.includes('#sightmap')) {
        $anchor.click(function (e) {
          e.preventDefault()
          $('[data-ecs-components-control="sightmap-trigger"]').trigger('click')
        })
      }

      // Handle fancybox gallery
      if (href.includes('#fancybox-gallery')) {
        const gallery = href.replace('#fancybox-gallery-', '')
        $anchor.attr('data-fancybox-trigger', gallery)
        $anchor.attr('href', 'javascript:;')
        $anchor.removeAttr('target')
      }

      // Handle fancybox video
      if (href.includes('#modal-video')) {
        const link = href.replace('#modal-video', '')
        $anchor.attr('data-fancybox', '')
        $anchor.attr('href', link)
      }

      // Handle fancybox iframe
      if (href.includes('#modal-iframe')) {
        const link = href.replace('#modal-iframe', '')
        $anchor.attr('data-fancybox', '')
        $anchor.attr('data-type', 'iframe')
        $anchor.attr('data-src', link)
      }

      // Handle Knock inquire link on Spaces plan detail page
      if (dataSpacesControl.includes('knock-contact')) {
        $anchor.click(function (e) {
          e.preventDefault()
          knockDoorway.openContact()
        })
      }
    })
  }

  return ComponentsAnchors
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentsAnchors = new COMPONENTS.ComponentsAnchors()
  COMPONENTS.componentsAnchors.init()
})
